<template>
  <section class="hero-section ahrs-root">
    <!-- Past AHRS photo backdrop (crossfade) -->
    <div class="hero-photos" aria-hidden="true">
      <img
        v-for="(photo, i) in photos"
        :key="photo"
        :src="photo"
        :class="{ active: i === activePhoto }"
        alt=""
      />
    </div>

    <!-- Ivory veil softening the photos -->
    <div class="hero-veil" aria-hidden="true"></div>

    <!-- Speaker poster wall (desktop) -->
    <div class="poster-wall" aria-hidden="true">
      <div
        v-for="(col, ci) in posterColumns"
        :key="'pw-col-' + ci"
        class="pw-col"
        :class="ci === 0 ? 'pw-up' : 'pw-down'"
      >
        <div class="pw-track">
          <div
            v-for="(poster, i) in col.concat(col)"
            :key="ci + '-' + i"
            class="pw-card"
          >
            <img :src="poster" alt="" loading="lazy" />
          </div>
        </div>
      </div>
    </div>

    <!-- Vertical edge label -->
    <div class="ahrs-edge">ONE AFRICA · ONE HR</div>

    <!-- Hero content -->
    <header class="ahrs-hero">
      <div class="eyebrow">
        <span class="dot"></span>Registration Now Open · 2nd Edition
      </div>

      <h1>
        <span class="ln"
          ><span
            ><span class="cg">2<sup class="ord">nd</sup>&nbsp;</span
            ><span class="cw">Africa&nbsp;</span
            ><span class="cg">Human</span></span
          ></span
        >
        <span class="ln"
          ><span
            ><span class="cw">Resource&nbsp;</span
            ><span class="cg">Summit</span></span
          ></span
        >
        <span class="ln"
          ><span><span class="cw">AHRS2026</span></span
        ></span>
      </h1>

      <p class="ahrs-sub">
        Theme — <em>Transforming Africa&rsquo;s Workforce for the Future.</em>
      </p>

      <div class="ahrs-meta">
        <div class="m">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
          >
            <rect x="3" y="4.5" width="18" height="17" rx="2" />
            <path d="M3 9h18M8 2.5v4M16 2.5v4" />
          </svg>
          19&ndash;22 August 2026
        </div>
        <div class="m">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
          >
            <path d="M12 21s7-5.6 7-11a7 7 0 1 0-14 0c0 5.4 7 11 7 11Z" />
            <circle cx="12" cy="10" r="2.6" />
          </svg>
          <span class="m-stack">
            <span>Mount Meru Hotel</span>
            <span>Arusha, Tanzania</span>
          </span>
        </div>
      </div>

      <div class="ahrs-actions">
        <router-link to="/registration" class="btn btn-primary">
          Register Now
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M5 12h14M13 6l6 6-6 6" />
          </svg>
        </router-link>
        <router-link to="/agenda" class="btn btn-ghost">
          View the Agenda
        </router-link>
      </div>

      <div class="ahrs-stats" aria-label="Countdown to AHRS 2026">
        <div class="s">
          <div class="n">{{ countdown.days }}</div>
          <div class="l">Days</div>
        </div>
        <div class="s">
          <div class="n">{{ countdown.hours }}</div>
          <div class="l">Hours</div>
        </div>
        <div class="s">
          <div class="n">{{ countdown.minutes }}</div>
          <div class="l">Minutes</div>
        </div>
        <div class="s">
          <div class="n">{{ countdown.seconds }}</div>
          <div class="l">Seconds</div>
        </div>
      </div>
    </header>

    <!-- Speaker poster strip (mobile / tablet) -->
    <div class="poster-strip" aria-hidden="true">
      <div class="ps-track">
        <div
          v-for="(poster, i) in posters.concat(posters)"
          :key="'ps-' + i"
          class="pw-card"
        >
          <img :src="poster" alt="" loading="lazy" />
        </div>
      </div>
    </div>

    <!-- Powered-by + ticker -->
    <div class="ahrs-bottom">
      <div class="powered">
        <span class="lbl">Powered<br />by</span>
        <img
          src="@/assets/images/logos/African Human Resource Confederation (AHRC).png"
          alt="African Human Resource Confederation"
        />
      </div>
      <div class="ahrs-ticker" aria-hidden="true">
        <div class="ahrs-track">
          <span>Future of Work</span>
          <span>Digital Transformation</span>
          <span>AI &amp; HR Ethics</span>
          <span>Talent &amp; Retention</span>
          <span>Mental Wellness</span>
          <span>Policy &amp; Reform</span>
          <span>Reskilling</span>
          <span>Pan-African Unity</span>
          <span>Future of Work</span>
          <span>Digital Transformation</span>
          <span>AI &amp; HR Ethics</span>
          <span>Talent &amp; Retention</span>
          <span>Mental Wellness</span>
          <span>Policy &amp; Reform</span>
          <span>Reskilling</span>
          <span>Pan-African Unity</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import photoMass from "@/assets/images/past Ahrs/mass.jpg";
import photoAward from "@/assets/images/past Ahrs/award.jpg";
import photoMember from "@/assets/images/past Ahrs/member.jpg";
import photoMemberr from "@/assets/images/past Ahrs/memberr.jpg";
import photoGuest from "@/assets/images/past Ahrs/guest.jpg";
import photoGuestMic from "@/assets/images/past Ahrs/guest with microphone.jpg";
import photoRoundTable from "@/assets/images/past Ahrs/round table.jpg";
import photoTalk from "@/assets/images/past Ahrs/talk.jpg";
import photoThinking from "@/assets/images/past Ahrs/thinking.jpg";
import photoAwardPhotos from "@/assets/images/past Ahrs/award photos.jpg";
import photoGroup from "@/assets/images/past Ahrs/Photo.jpg";

// Load every speaker poster from the posters folder (webpack require.context)
const posterCtx = require.context("@/assets/posters", false, /\.jpe?g$/i);
const posters = posterCtx.keys().sort().map((key) => {
  const mod = posterCtx(key);
  return mod && mod.default ? mod.default : mod;
});

export default {
  name: "HeroSection",
  data() {
    return {
      posters,
      countdown: {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      },
      countdownInterval: null,
      photos: [
        photoMass,
        photoAward,
        photoMember,
        photoMemberr,
        photoGuest,
        photoGuestMic,
        photoRoundTable,
        photoTalk,
        photoThinking,
        photoAwardPhotos,
        photoGroup,
      ],
      activePhoto: 0,
      photoInterval: null,
    };
  },
  computed: {
    // Split posters into two columns that scroll in opposite directions
    posterColumns() {
      const colA = [];
      const colB = [];
      this.posters.forEach((poster, i) => {
        (i % 2 === 0 ? colA : colB).push(poster);
      });
      return [colA, colB];
    },
  },
  mounted() {
    this.startCountdown();
    this.startPhotoCycle();
  },
  beforeUnmount() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
    if (this.photoInterval) {
      clearInterval(this.photoInterval);
    }
  },
  methods: {
    startPhotoCycle() {
      this.photoInterval = setInterval(() => {
        this.activePhoto = (this.activePhoto + 1) % this.photos.length;
      }, 12000);
    },
    startCountdown() {
      const targetDate = new Date("2026-08-19T09:00:00").getTime();

      this.countdownInterval = setInterval(() => {
        const now = new Date().getTime();
        const distance = targetDate - now;

        if (distance > 0) {
          this.countdown.days = Math.floor(distance / (1000 * 60 * 60 * 24));
          this.countdown.hours = Math.floor(
            (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          );
          this.countdown.minutes = Math.floor(
            (distance % (1000 * 60 * 60)) / (1000 * 60)
          );
          this.countdown.seconds = Math.floor((distance % (1000 * 60)) / 1000);
        } else {
          this.countdown = { days: 0, hours: 0, minutes: 0, seconds: 0 };
        }
      }, 1000);
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500;1,600;1,700&display=swap");

.ahrs-root *,
.ahrs-root *::before,
.ahrs-root *::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.ahrs-root {
  --green: #119549;
  --green-deep: #0c6e37;
  --green-bright: #16a85a;
  --bg-0: #f3f8f3;
  --bg-1: #e6f1e8;
  --ink: #10271b;
  --body: #425a4c;
  --muted: #6f8a79;
  --line: rgba(17, 149, 73, 0.2);
  font-family: "Inter", "Segoe UI", sans-serif;
  color: var(--ink);
  position: relative;
  overflow: hidden;
  isolation: isolate;
  background: radial-gradient(
      120% 95% at 86% 6%,
      rgba(22, 168, 90, 0.2) 0%,
      transparent 46%
    ),
    radial-gradient(
      90% 75% at -5% 105%,
      rgba(17, 149, 73, 0.14) 0%,
      transparent 52%
    ),
    linear-gradient(165deg, var(--bg-0) 0%, var(--bg-1) 100%);
  -webkit-font-smoothing: antialiased;
  padding-top: 78px;
}

.ahrs-root::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 2;
  pointer-events: none;
  opacity: 0.55;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.8' numOctaves='3'/%3E%3CfeColorMatrix type='saturate' values='0'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='.04'/%3E%3C/svg%3E");
  mix-blend-mode: multiply;
}

/* Past AHRS photo crossfade backdrop */
.hero-photos {
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  overflow: hidden;
}
.hero-photos img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 40%;
  opacity: 0;
  transform: scale(1.06) translateX(0);
  transition: opacity 3s ease-in-out;
}
.hero-photos img.active {
  opacity: 1;
  animation: slowDrift 14s ease-in-out forwards;
}
@keyframes slowDrift {
  from {
    transform: scale(1.1) translateX(1.5%);
  }
  to {
    transform: scale(1.02) translateX(-2.5%);
  }
}

/* Green veil softening the photos so text stays legible */
.hero-veil {
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  background: linear-gradient(
      180deg,
      rgba(17, 149, 73, 0.55) 0%,
      rgba(17, 149, 73, 0.68) 55%,
      rgba(12, 110, 55, 0.78) 100%
    ),
    radial-gradient(
      120% 95% at 86% 6%,
      rgba(22, 168, 90, 0.28) 0%,
      transparent 46%
    ),
    radial-gradient(
      90% 75% at -5% 105%,
      rgba(12, 110, 55, 0.32) 0%,
      transparent 52%
    );
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
}

/* Speaker poster wall — tilted, dual auto-scrolling columns */
.poster-wall {
  position: absolute;
  z-index: 2;
  top: 0;
  bottom: 0;
  right: 0;
  width: clamp(380px, 48%, 760px);
  display: flex;
  justify-content: flex-end;
  gap: 20px;
  padding: 0 clamp(20px, 3vw, 52px) 0 0;
  pointer-events: none;
  transform: perspective(1700px) rotateY(-18deg) rotateX(4deg) rotateZ(-3deg);
  transform-origin: right center;
  -webkit-mask: linear-gradient(
      180deg,
      transparent 0,
      #000 14%,
      #000 84%,
      transparent 100%
    ),
    linear-gradient(90deg, transparent 0, #000 28%);
  -webkit-mask-composite: source-in;
  mask: linear-gradient(
      180deg,
      transparent 0,
      #000 14%,
      #000 84%,
      transparent 100%
    ),
    linear-gradient(90deg, transparent 0, #000 28%);
  mask-composite: intersect;
}
.pw-col {
  width: clamp(210px, 17vw, 300px);
  flex: none;
  overflow: hidden;
}
.pw-track {
  display: flex;
  flex-direction: column;
  gap: 20px;
  will-change: transform;
}
.pw-up .pw-track {
  animation: pwScrollUp 80s linear infinite;
}
.pw-down .pw-track {
  animation: pwScrollDown 80s linear infinite;
}
@keyframes pwScrollUp {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-50%);
  }
}
@keyframes pwScrollDown {
  from {
    transform: translateY(-50%);
  }
  to {
    transform: translateY(0);
  }
}
.pw-card {
  border-radius: 16px;
  overflow: hidden;
  background: #fff;
  border: 1px solid rgba(255, 255, 255, 0.55);
  box-shadow: 0 22px 48px -20px rgba(6, 40, 22, 0.7),
    0 4px 14px -8px rgba(6, 40, 22, 0.45);
}
.pw-card img {
  display: block;
  width: 100%;
  height: auto;
}

/* Mobile / tablet horizontal poster strip — hidden on desktop */
.poster-strip {
  display: none;
}
.ps-track {
  display: flex;
  gap: 14px;
  width: max-content;
  animation: psScroll 70s linear infinite;
}
.ps-track .pw-card {
  width: 160px;
  flex: none;
  border-radius: 12px;
}
@keyframes psScroll {
  to {
    transform: translateX(-50%);
  }
}

.ahrs-edge {
  position: absolute;
  left: 34px;
  top: 50%;
  z-index: 3;
  transform: translateY(-50%) rotate(180deg);
  writing-mode: vertical-rl;
  font-size: 11px;
  letter-spacing: 0.42em;
  text-transform: uppercase;
  color: rgba(251, 247, 236, 0.85);
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 18px;
}
.ahrs-edge::after {
  content: "";
  width: 1px;
  height: 64px;
  background: linear-gradient(rgba(251, 247, 236, 0.7), transparent);
}

.ahrs-hero {
  position: relative;
  z-index: 4;
  padding: clamp(20px, 3vh, 36px) clamp(24px, 5vw, 64px) 86px;
  max-width: 640px;
}

.eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 6px 14px 6px 10px;
  border: 1px solid rgba(251, 247, 236, 0.3);
  border-radius: 100px;
  background: rgba(255, 255, 255, 0.14);
  font-size: 11px;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  font-weight: 600;
  color: #fbf7ec;
  margin-bottom: 18px;
  animation: fadeUp 1s 0.25s both cubic-bezier(0.2, 0.7, 0.2, 1);
}
.eyebrow .dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--green-bright);
  box-shadow: 0 0 0 4px rgba(22, 168, 90, 0.2);
  animation: pulse 2.4s ease-in-out infinite;
}
@keyframes pulse {
  0%,
  100% {
    box-shadow: 0 0 0 4px rgba(22, 168, 90, 0.2);
  }
  50% {
    box-shadow: 0 0 0 7px rgba(22, 168, 90, 0.06);
  }
}

.ahrs-hero h1 {
  font-family: "Playfair Display", "Times New Roman", serif;
  font-weight: 600;
  font-size: clamp(34px, 5.4vw, 72px);
  line-height: 1.05;
  letter-spacing: -0.015em;
  color: #fbf7ec;
  margin-bottom: 16px;
}
.ahrs-hero h1 .accent {
  font-style: italic;
  font-weight: 500;
  background: linear-gradient(100deg, #fbf7ec, #b8f0c8);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.ahrs-hero h1 .ord {
  font-size: 0.42em;
  vertical-align: 0.85em;
  font-weight: 500;
  letter-spacing: 0.04em;
  margin-left: 0.04em;
}
.ahrs-hero h1 .cw {
  color: #fbf7ec;
}
.ahrs-hero h1 .cg {
  color: #0a3a1f;
}
.ahrs-hero h1 .ln {
  display: block;
  overflow: hidden;
}
.ahrs-hero h1 .ln > span {
  display: block;
  animation: rise 1.05s both cubic-bezier(0.22, 0.8, 0.18, 1);
}
.ahrs-hero h1 .ln:nth-child(1) > span {
  animation-delay: 0.34s;
}
.ahrs-hero h1 .ln:nth-child(2) > span {
  animation-delay: 0.46s;
}
.ahrs-hero h1 .ln:nth-child(3) > span {
  animation-delay: 0.58s;
}

.ahrs-sub {
  max-width: none;
  font-size: clamp(18px, 1.6vw, 24px);
  line-height: 1.4;
  color: rgba(251, 247, 236, 0.92);
  margin-bottom: 26px;
  white-space: nowrap;
  animation: fadeUp 1s 0.62s both cubic-bezier(0.2, 0.7, 0.2, 1);
}
.ahrs-sub em {
  font-style: italic;
  color: #b8f0c8;
  font-weight: 500;
}

.ahrs-meta {
  display: flex;
  gap: 22px;
  flex-wrap: wrap;
  margin-bottom: 24px;
  animation: fadeUp 1s 0.7s both cubic-bezier(0.2, 0.7, 0.2, 1);
}
.ahrs-meta .m {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 17px;
  color: #fbf7ec;
  font-weight: 600;
}
.ahrs-meta svg {
  width: 22px;
  height: 22px;
  stroke: rgba(251, 247, 236, 0.9);
  flex: none;
}
.ahrs-meta .m-stack {
  display: inline-flex;
  flex-direction: column;
  line-height: 1.25;
}

.ahrs-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 28px;
  animation: fadeUp 1s 0.8s both cubic-bezier(0.2, 0.7, 0.2, 1);
}
.btn {
  font-family: inherit;
  font-size: 16.5px;
  font-weight: 600;
  cursor: pointer;
  border-radius: 100px;
  padding: 15px 30px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  border: 1px solid transparent;
  text-decoration: none;
  transition: transform 0.3s, box-shadow 0.3s, background 0.3s,
    border-color 0.3s, color 0.3s;
}
.btn-primary {
  background: var(--green);
  color: #fff;
  box-shadow: 0 12px 32px -10px rgba(17, 149, 73, 0.65);
}
.btn-primary:hover {
  background: var(--green-bright);
  transform: translateY(-2px);
  box-shadow: 0 18px 42px -10px rgba(22, 168, 90, 0.75);
  color: #fff;
}
.btn-primary svg {
  width: 18px;
  height: 18px;
  transition: transform 0.3s;
}
.btn-primary:hover svg {
  transform: translateX(4px);
}
.btn-ghost {
  background: rgba(255, 255, 255, 0.14);
  color: #fbf7ec;
  border-color: rgba(251, 247, 236, 0.4);
}
.btn-ghost:hover {
  border-color: rgba(251, 247, 236, 0.85);
  background: rgba(255, 255, 255, 0.24);
  transform: translateY(-2px);
  color: #fbf7ec;
}

.ahrs-stats {
  display: flex;
  gap: clamp(20px, 4vw, 48px);
  flex-wrap: wrap;
  padding-top: 20px;
  border-top: 1px solid rgba(251, 247, 236, 0.25);
  max-width: 640px;
  animation: fadeUp 1s 0.95s both cubic-bezier(0.2, 0.7, 0.2, 1);
}
.ahrs-stats .s .n {
  font-family: "Playfair Display", "Times New Roman", serif;
  font-size: clamp(30px, 3vw, 42px);
  font-weight: 600;
  color: #fbf7ec;
  line-height: 1;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.01em;
}
.ahrs-stats .s .l {
  margin-top: 8px;
  font-size: 12px;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: rgba(251, 247, 236, 0.7);
  font-weight: 600;
}

.ahrs-bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 3;
  display: flex;
  align-items: center;
  border-top: 1px solid var(--line);
  background: rgba(255, 255, 255, 0.42);
  backdrop-filter: blur(8px);
  animation: fadeUp 1s 1.1s both cubic-bezier(0.2, 0.7, 0.2, 1);
}
.powered {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 9px clamp(24px, 5vw, 64px);
  border-right: 1px solid var(--line);
  flex: none;
}
.powered .lbl {
  font-size: 9.5px;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--muted);
  font-weight: 700;
  line-height: 1.3;
}
.powered img {
  height: 46px;
  width: auto;
  display: block;
}
.ahrs-ticker {
  overflow: hidden;
  flex: 1;
  -webkit-mask-image: linear-gradient(
    90deg,
    transparent,
    #000 6%,
    #000 94%,
    transparent
  );
  mask-image: linear-gradient(
    90deg,
    transparent,
    #000 6%,
    #000 94%,
    transparent
  );
}
.ahrs-track {
  display: flex;
  gap: 42px;
  width: max-content;
  animation: scroll 32s linear infinite;
  padding-left: 24px;
}
.ahrs-track span {
  font-size: 12.5px;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: var(--muted);
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 42px;
  white-space: nowrap;
}
.ahrs-track span::after {
  content: "◆";
  color: var(--green);
  font-size: 7px;
}
@keyframes scroll {
  to {
    transform: translateX(-50%);
  }
}

@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(26px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes rise {
  from {
    transform: translateY(108%);
  }
  to {
    transform: translateY(0);
  }
}

@media (max-width: 1180px) {
  .poster-wall {
    width: clamp(340px, 46%, 600px);
  }
  .ahrs-edge {
    left: 18px;
  }
  .ahrs-hero {
    padding-bottom: 96px;
  }
}

/* Swap the tilted wall for a horizontal strip on tablet / mobile */
@media (max-width: 1024px) {
  .poster-wall {
    display: none;
  }
  .ahrs-hero {
    max-width: 960px;
    padding-bottom: 24px;
  }
  .poster-strip {
    display: block;
    position: relative;
    z-index: 4;
    margin: 6px clamp(18px, 5vw, 28px) 96px;
    overflow: hidden;
    -webkit-mask-image: linear-gradient(
      90deg,
      transparent,
      #000 5%,
      #000 95%,
      transparent
    );
    mask-image: linear-gradient(
      90deg,
      transparent,
      #000 5%,
      #000 95%,
      transparent
    );
  }
}

@media (max-width: 860px) {
  .ahrs-root {
    padding-top: 72px;
  }
  .ahrs-edge {
    display: none;
  }
  .ahrs-hero {
    padding: clamp(20px, 4vh, 36px) clamp(18px, 5vw, 28px) 20px;
  }
  .ahrs-hero h1 {
    font-size: clamp(30px, 7vw, 48px);
    margin-bottom: 14px;
  }
  .ahrs-sub {
    font-size: 15px;
    margin-bottom: 22px;
    white-space: normal;
  }
  .ahrs-meta {
    gap: 14px;
    margin-bottom: 20px;
  }
  .ahrs-actions {
    margin-bottom: 22px;
  }
  .ahrs-actions .btn {
    padding: 13px 24px;
    font-size: 15px;
  }
  .ahrs-stats {
    gap: 18px;
    padding-top: 16px;
  }
  .ahrs-stats .s .n {
    font-size: clamp(26px, 6vw, 36px);
  }
  .ahrs-ticker {
    display: none;
  }
  .powered {
    border-right: none;
    width: 100%;
    justify-content: center;
    padding: 10px 20px;
  }
  .hero-veil {
    background: linear-gradient(
      180deg,
      rgba(17, 149, 73, 0.65) 0%,
      rgba(17, 149, 73, 0.78) 55%,
      rgba(12, 110, 55, 0.86) 100%
    );
  }
}

@media (max-width: 480px) {
  .ahrs-stats {
    gap: 16px;
  }
  .ahrs-stats .s .n {
    font-size: 30px;
  }
  .ahrs-stats .s .l {
    font-size: 11px;
  }
  .ahrs-meta .m {
    font-size: 15px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .ahrs-root * {
    animation: none !important;
  }
}
</style>
